import React, { useEffect, useRef } from 'react';
import { Dropdown, useDropdown } from '@vtblife/uikit';

import './styles.css';

import { OfferRoute } from '../../../../domain/offer/search/page/SearchOffersQuery';
import { OfferRouteCard } from '../OfferRouteCard';

export interface OfferRouteCardListProps {
    offerRoutes: OfferRoute[];
    noClickable?: boolean;
}

const CustomTrigger: React.FC = ({ children }) => {
    const { toggle, registerControl } = useDropdown();
    const control = useRef<HTMLSpanElement | null>(null);

    useEffect(() => {
        registerControl(control.current as HTMLElement);
    }, [ registerControl ]);

    return (
        <span
            ref={control}
            onMouseEnter={toggle}
            onMouseLeave={toggle}
            className='OfferRouteCardList__more'
        >
            Ещё {children}
        </span>
    );
};

export function OfferRouteCardList({ offerRoutes, noClickable }: OfferRouteCardListProps) {
    const part1 = offerRoutes.slice(0, 3);
    const part2 = offerRoutes.slice(3);

    return (
        <div className='OfferRouteCardList'>
            {part1.map(offerRoute => (
                <OfferRouteCard
                    key={offerRoute.metro.id}
                    offerRoute={offerRoute}
                    className='OfferRouteCardList__item'
                    noClickable={noClickable}
                />
            ))}
            {part2.length > 0 && (
                <Dropdown>
                    <CustomTrigger>
                        {part2.length}
                    </CustomTrigger>
                    <Dropdown.Content>
                        <div className='OfferRouteCardList__moreContent'>
                            {part2.map(offerRoute => (
                                <OfferRouteCard
                                    key={offerRoute.metro.id}
                                    offerRoute={offerRoute}
                                    className='OfferRouteCardList__item'
                                    noClickable={noClickable}
                                />
                            ))}
                        </div>
                    </Dropdown.Content>
                </Dropdown>
            )}
        </div>
    );
}
